import axios from "axios";
import React, { useEffect, useState } from "react";

function Client() {
  const [Clientele, setClientele] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/our_product_list"
      );
      setClientele(response.data.data);
    };

    fetchData();
  }, []);

  return (
    <div className="container-fluid client-title" >
      
      <div className="container">
        <h1 className="heading-about " data-aos="fade-up" data-aos-delay={20}>
          <strong>Our Clients</strong>
        </h1>
      </div>
   
      <div className="container-fluid icon">
        <div className="marquee hover-pause">
          <div className="marquee-content left-scroll">
            {Clientele.map((Data, index) => (
            <li key={index}>
              <img
                src={`https://cyberathon.com/NLF/${Data.our_images}`}
                alt="Client images"
                className="img-contain"
                style={{ height: 100 }}
              />
            </li>
            ))}
          </div>

           {/* <div className="marquee-content left-scroll">
            <li key={index}>
              <img
                src={`https://cyberathon.com/NLF/${Data.our_images}`}
                alt="Moscord"
                className="img-contain"
                style={{ height: 100 }}
              />
            </li>
          </div>  */}
        </div>
      </div>
      </div>
  );
}

export default Client;
